<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="400">
    <v-tabs v-model="model" fixed-tabs>
      <v-tab v-for="(tab, index) in tabs" :key="'Tab ' + index" active-class="active-class">{{
        tab
      }}</v-tab>
      <v-tabs-slider class="custom-text" />
      <v-tabs-items v-model="model">
        <v-tab-item v-for="(tab, index) in tabs" :key="'Item ' + index">
          <component
            :is="components[tab]"
            @teacher-updated="$emit('teacher-updated', $event)"
          ></component>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-dialog>
</template>
<script>
export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      tabs: ["Profile", "Password"],
      model: 0,
      components: {
        Profile: () => import("./Profile.vue"),
        Password: () => import("./ChangePassword.vue"),
      },
    };
  },
};
</script>
